import PortalIdParser from 'PortalIdParser';
import { AppContext } from 'in-meeting-experience-ui-components/contexts/app/context';
import Raven from 'raven-js';
import { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { routes } from '../constants/routes';
import { canViewParticipantsSelector } from '../slices/google/selectors';
import { googleActions } from '../slices/google/slice';
const useOutsideMeetingExperienceListener = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    isInMeeting,
    selectors: {
      isInLiveMeeting
    }
  } = useContext(AppContext);
  const canViewParticipants = useSelector(canViewParticipantsSelector);

  // set empty context to make ability to set any call object UUID
  useEffect(() => {
    if (isInMeeting === false) {
      dispatch(googleActions.receiveMeetingContext({
        canViewParticipants: true,
        meetingTopic: '',
        meetingUUID: '',
        meetingID: ''
      }));
    }
  }, [dispatch, isInMeeting]);

  // redirect to outside meeting list
  useEffect(() => {
    if (isInMeeting === false && !history.location.pathname.includes(routes.outsideMeeting)) {
      Raven.captureBreadcrumb({
        message: 'useOutsideMeetingExperienceListener.redirect.outside.meeting',
        level: 'debug',
        data: isInMeeting
      });
      history.replace(`/${PortalIdParser.getPortalIdFromPath()}${routes.outsideMeeting}`);
    }
  }, [history, isInMeeting]);

  // redirect user to regular routes
  useEffect(() => {
    if (isInLiveMeeting && history.location.pathname.includes(routes.outsideMeeting)) {
      Raven.captureBreadcrumb({
        message: 'useOutsideMeetingExperienceListener.redirect.in.meeting',
        level: 'debug',
        data: isInLiveMeeting
      });
      history.replace(`/${PortalIdParser.getPortalIdFromPath()}/${canViewParticipants ? routes.contacts : routes.associations}`);
    }
  }, [canViewParticipants, history, isInLiveMeeting]);
};
export default useOutsideMeetingExperienceListener;